import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { StoryCard } from "@/components/StoryCard";
import { usePageSeo } from "@/hooks/usePageSeo";
import { getStoryHaystack } from "@/utils/newsroomCollections";

export const SearchPage = ({ feed }) => {
  const location = useLocation();
  const searchTerm = new URLSearchParams(location.search).get("q") || "";
  const stories = useMemo(() => (feed || []).filter((story) => getStoryHaystack(story).includes(searchTerm.toLowerCase())), [feed, searchTerm]);

  usePageSeo({ canonicalPath: `/search${location.search}`, description: `Search results for ${searchTerm} on Content Watch HQ.`, title: `${searchTerm || "Search"} | Content Watch HQ` });

  return (
    <main className="page-shell mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8" data-testid="search-page">
      <section className="border border-[#D9DCE1] bg-white p-6" data-testid="search-page-hero">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#1338BE]">Search</p>
        <h1 className="mt-3 font-[Bebas_Neue] text-5xl uppercase tracking-[0.04em] text-[#0A0A0A] sm:text-6xl" data-testid="search-page-title">Results for “{searchTerm || "all coverage"}”</h1>
      </section>
      <section className="news-card-grid mt-8" data-testid="search-page-grid">
        {stories.map((story) => <StoryCard key={story.id || story.slug} story={story} />)}
      </section>
    </main>
  );
};